export default {"src":"/_next/static/media/sendIcon.e2050431.svg","height":14,"width":16};